import { createFeatureSelector, MemoizedSelector } from '@ngrx/store';
import { SEO_FEATURE, SeoState, StateWithSeo } from '../seo-state';

export const getFeatureState: MemoizedSelector<StateWithSeo, SeoState> = createFeatureSelector<SeoState>(SEO_FEATURE);
